
export const searchRoute: any[] = [
  {
    "id": "3",
    "tenantId": "1",
    "authorityKey": "/search",
    "type": 0,
    "name": "查询工具",
    "path": "/search",
    "icon": "",
    "sort": 3,
    "component": "../views/Search/pages/Index",
    "parentId": null,
    "isChecked": 0,
    "isHide": 0,
    "status": null,
    "deleted": null,
    "tenantHave": null,
    "subMenu": null,
    "buttons": [
        {
            "id": "6",
            "tenantId": "1",
            "authorityKey": "/search/business/:recordNo?",
            "type": 2,
            "name": "查工商",
            "path": "/search/business/:recordNo?",
            "icon": null,
            "sort": 1,
            "component": "../views/Search/pages/Business",
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "GSXX"
        },
        {
            "id": "18",
            "tenantId": "1",
            "authorityKey": "/search/verification/three",
            "type": 2,
            "name": "三要素核验",
            "path": null,
            "icon": null,
            "sort": 1,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CVTA"
        },
        {
            "id": "20",
            "tenantId": "1",
            "authorityKey": "/search/carSearch/myCar",
            "type": 2,
            "name": "名下车辆",
            "path": null,
            "icon": null,
            "sort": 1,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CLXX_A"
        },
        {
            "id": "19",
            "tenantId": "1",
            "authorityKey": "/search/verification/four",
            "type": 2,
            "name": "四要素核验",
            "path": null,
            "icon": null,
            "sort": 2,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CVFA"
        },
        {
            "id": "7",
            "tenantId": "1",
            "authorityKey": "/search/lawsuit/:recordNo?",
            "type": 2,
            "name": "个人诉讼",
            "path": "/search/lawsuit/:recordNo?",
            "icon": null,
            "sort": 2,
            "component": "../views/Search/pages/Lawsuit",
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "GRSS"
        },
        {
            "id": "21",
            "tenantId": "1",
            "authorityKey": "/search/carSearch/transferNum",
            "type": 2,
            "name": "过户次数",
            "path": null,
            "icon": null,
            "sort": 2,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CLXX_B"
        },
        {
            "id": "8",
            "tenantId": "1",
            "authorityKey": "/search/enterpriseLawsuit/:recordNo?",
            "type": 2,
            "name": "企业诉讼",
            "path": "/search/enterprise-lawsuit/:recordNo?",
            "icon": null,
            "sort": 3,
            "component": "../views/Search/pages/Lawsuit",
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "QYSS"
        },
        {
            "id": "22",
            "tenantId": "1",
            "authorityKey": "/search/carSearch/ownerVerification",
            "type": 2,
            "name": "人/企车主核验",
            "path": null,
            "icon": null,
            "sort": 3,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CLXX_C"
        },
        {
            "id": "23",
            "tenantId": "1",
            "authorityKey": "/search/carSearch/usedCar",
            "type": 2,
            "name": "二手车精准评估",
            "path": null,
            "icon": null,
            "sort": 4,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CLXX_D"
        },
        {
            "id": "24",
            "tenantId": "1",
            "authorityKey": "/search/carSearch/carFiveItems",
            "type": 2,
            "name": "车五项查询",
            "path": null,
            "icon": null,
            "sort": 5,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CLXX_E"
        },
        {
            "id": "25",
            "tenantId": "1",
            "authorityKey": "/search/carSearch/drivingPermit",
            "type": 2,
            "name": "行驶证查询",
            "path": null,
            "icon": null,
            "sort": 6,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CLXX_F"
        },
        {
            "id": "10",
            "tenantId": "1",
            "authorityKey": "/search/socialSecurity/:recordNo?",
            "type": 2,
            "name": "广东社保",
            "path": "/search/social-security/:recordNo?",
            "icon": null,
            "sort": 6,
            "component": "../views/Search/pages/SocialSecurity",
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "GRSB"
        },
        {
            "id": "26",
            "tenantId": "1",
            "authorityKey": "/search/carSearch/carInsurance",
            "type": 2,
            "name": "车辆保险查询",
            "path": null,
            "icon": null,
            "sort": 7,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CLXX_H"
        },
        {
            "id": "11",
            "tenantId": "1",
            "authorityKey": "/search/marital/:recordNo?",
            "type": 2,
            "name": "婚姻状况",
            "path": "/search/marital/:recordNo?",
            "icon": null,
            "sort": 7,
            "component": "../views/Search/pages/Marital",
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "HYZT"
        },
        {
            "id": "27",
            "tenantId": "1",
            "authorityKey": "/search/carSearch/accidentRecords",
            "type": 2,
            "name": "出险详情记录",
            "path": null,
            "icon": null,
            "sort": 8,
            "component": null,
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "CLXX_G"
        },
        {
            "id": "12",
            "tenantId": "1",
            "authorityKey": "/search/historicalTransaction/:recordNo?",
            "type": 2,
            "name": "历史成交",
            "path": "/search/historical-transaction/:recordNo?",
            "icon": null,
            "sort": 8,
            "component": "../views/Search/pages/HistoricalTransaction",
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "LSCJ"
        }
    ],
    "children": [
        {
            "id": "14",
            "tenantId": "1",
            "authorityKey": "/search/diySearch",
            "type": 1,
            "name": "自定义查",
            "path": "/search/diySearch",
            "icon": null,
            "sort": 1,
            "component": "../views/Search/pages/DiySearch",
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "ZDYC"
        },
        {
            "id": "15",
            "tenantId": "1",
            "authorityKey": "/search/realEstateAssessment/:recordNo?",
            "type": 1,
            "name": "房产评估",
            "path": "/search/real-estate-assessment/:recordNo?",
            "icon": null,
            "sort": 2,
            "component": "../views/Search/pages/RealEstateAssessment",
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": "FCPG"
        },
        {
            "id": "66",
            "tenantId": "1",
            "authorityKey": "/search/enterpriseTaxInvoice",
            "type": 1,
            "name": "水母报告Plus",
            "path": "/search/enterprise-taxInvoice/:recordNo?",
            "icon": null,
            "sort": 4,
            "component": "../views/Search/pages/EnterpriseTaxInvoice",
            "parentId": "3",
            "isChecked": 0,
            "isHide": 0,
            "status": null,
            "deleted": null,
            "tenantHave": null,
            "subMenu": null,
            "buttons": [],
            "children": [],
            "queryDictKey": null
        }
    ],
    "queryDictKey": null
  }
]
